import { Component, OnInit } from '@angular/core';
import { DateService } from 'app/shared/services/date.service';
import { UtilService } from 'app/shared/util.service';
import { Hotel } from 'app/shared/model/hotel';
import { Router } from '@angular/router';

@Component({
    selector: 'mh-online-summary-section',
    templateUrl: './online-summary-section.component.html',
    styleUrls: ['./online-summary-section.component.scss'],
    standalone: false
})
export class OnlineSummarySectionsComponent implements OnInit {
  productId = 3;

  chain: Hotel[] = [];
  chainFilter: Hotel[] = [];
  originalChainFilter: Hotel[] = [];
  isReady = false;
  dates: { startDate: string; endDate: string };

  constructor(private dateService: DateService, private utilService: UtilService, private router: Router) {}

  ngOnInit(): void {
    this.utilService.setGeneralFade(false);
    setTimeout(() => {
      this.chain = this.utilService.getChain(String(this.productId));
    }, 0);
    const currentDates = this.dateService.currentDates;
    this.dates = {
      startDate: currentDates.startDate,
      endDate: currentDates.endDate,
    };
  }

  setChain(chain: Hotel[]): void {
    setTimeout(() => {
      this.dataIsReady(chain.length !== 0);
      this.originalChainFilter = [...chain];
      this.chainFilter = [...chain];
    }, 0);
  }

  setHotelsFilter(hotels: Hotel[]): void {
    this.chainFilter = [...hotels];
  }

  dataIsReady(state: boolean): void {
    setTimeout(() => {
      this.isReady = state;
    }, 200);
  }

  handleDatepickerUpdated($event: {
    currentFilter: unknown;
    currentDates: { startDate: string; endDate: string };
  }): void {
    this.dateService.setCurrentFilter($event.currentFilter);
    this.dateService.setCurrentDates($event.currentDates);
    this.dates = {
      startDate: $event.currentDates.startDate,
      endDate: $event.currentDates.endDate,
    };
  }

  get currentDates(): { startDate: string; endDate: string } {
    return this.dates;
  }

  get currentFilterDate(): unknown {
    return this.dateService.currentFilter;
  }

  get fidelityPermissions(): string[] {
    return this.utilService.getFidelityConfigurationsByProduct('interchain', 'interchain_online') || [];
  }

  get shouldShowSummary(): boolean {
    return (
      this.chainFilter.length > 0 &&
      this.isReady &&
      this.fidelityPermissions.includes('interchain_online_summary_result')
    );
  }

  get isHotelsFilterDisabled(): boolean {
    return !this.isReady || this.originalChainFilter.length === 0;
  }
}
